export default {
  darkModeState: (state) => state.layoutMode.dark,
  rtlModeState: (state) => state.layoutMode.rtl,
  selectedMenuState: (state) => state.selectedMenu,
  shopUrl: (state) => state.isShopUrl,
}
